import React from 'react'

import {
  AppearingWrapper,
  Description,
  SectionContainer,
} from 'Components/Blocks'
import { Column } from 'Components/UI'
import { NewsItem } from 'Types/emajinAPI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Gallery from './Gallery'

type Props = {
  data?: NewsItem
}

function BlogPostBodySection({ data }: Props) {
  if (!data) return null

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Column
          fullWidth
          gap={5}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          px={LANDING_CONTENT_PX}
        >
          <Description value={data?.description ?? ''} />

          <Gallery data={data} />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default BlogPostBodySection
